export function getCSVColumns (report)
{
	switch(report)
	{
		case 'residential-lead':
			return [
				'Lead Name',
				'Franchise',
				'Lead Status',
				'Lead Creation Date',
				'Zip Code',
				'Lead Stage',
				'Last Contacted Date',
				'Outreach',
				'Channel Attribution',
				'How Hear',
				'Email'
			];
		case 'residential-signup':
			return [
				'Customer Name',
				'Franchise',
				'Customer Status',
				'Joined Date',
				'Frequency',
				'Last Service',
				'Service Address',
				'City',
				'State',
				'Zipcode',
				'Channel Attribution',
				'How Hear',
				'Email',
			];
		case 'commercial-proposal':
			return [
				'Community Name',
				'Community Manager',
				'Management Company',
				'Property Type',
				'Franchise',
				'Proposal Creation Date',
				'Services',
				'Products',
				'Service Street Address',
				'Service City',
				'Service State',
				'Zip Code',
				'Outreach',
				'Channel Attribution',
				'How Hear',
				'Email Addresss',
			];
		case 'commercial-signup':
			return [
				'Community Name',
				'Community Manager',
				'Management Company',
				'Property Type',
				'Franchise',
				'Joined Date',
				'Services',
				'Products',
				'Frequency',
				'Service Street Address',
				'Service City',
				'Service State',
				'Zip Code',
				'Outreach',
				'Channel Attribution',
				'How Hear',
				'Email Addresss',
			];
		case 'cancellation':
			return [
				'Customer Name',
				'Franchise',
				'Signup Date',
				'Service Address',
				'City',
				'State',
				'Zip Code',
				'Channel Attribution',
				'Reason for Cancellation',
				'Cancellation Date',
				'Frequency',
				'Email Addresss',
			];
	}
}